export enum NotFoundErrorType {
  URL_NOT_FOUND,
  RESOURCE_NOT_FOUND
}
